import React, {useState} from 'react';
import ArrPaginationPro from '../../../components/common/arr-pagination-pro/ArrPaginationPro';
import {Box, Typography} from '@mui/material';
const ArrPaginationDemo: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(200);
  const totalEntries = 2500;

  const handlePageChange = (index: number) => {
    const page = Math.ceil(index / pageSize);
    setCurrentPage(page);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
  };

  return (
    <Box className=" pagination-demo">
      <Typography component="h1" className="typo-text headline1_size">
        PaginationPro
      </Typography>
      <Box marginTop={5}>
        <Typography component="h2"> Full Pagination</Typography>
        <ArrPaginationPro
          currentPage={currentPage}
          pageSize={pageSize}
          totalEntries={totalEntries}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      </Box>
    </Box>
  );
};

export default ArrPaginationDemo;
